export default {
    nav: {
        home: 'Início',
        products: 'Produtos',
        solutions: 'Soluções',
        support: 'Suporte',
        aboutUs: 'Sobre nós',
        contact: 'Fale conosco'
    },
    hero: {
        title: 'Kooyii Smart<br>Soluções Completas para Espaços Inteligentes e Alarmes de Segurança',
        desc: 'Tornando os espaços mais inteligentes, seguros e protegidos.'
    },
    protocol: {
        title: 'Protocolos de Comunicação',
        cards: {
            zigbee: 'O Zigbee 3.0 é um padrão de comunicação sem fio unificado introduzido pela Connectivity Standards Alliance (CSA), permitindo interoperabilidade perfeita entre marcas e redes mesh de baixo consumo, integrando protocolos de aplicativos fragmentados.',
            wifi: 'O Wi-Fi é uma tecnologia de rede sem fio reconhecida globalmente que transmite dados por meio de ondas de rádio, permitindo que os dispositivos se conectem a redes sem cabos físicos.',
            rf433: '433MHz é uma banda de rádio de baixa frequência comumente usada para dispositivos de curto alcance e baixo consumo de energia, como sistemas de alarme de segurança e interruptores inteligentes.',
            modbus: 'Modbus é um protocolo de comunicação serial amplamente utilizado na automação industrial, suportando comunicação mestre-escravo e troca de dados.',
            knx: 'KNX é uma tecnologia de barramento padrão europeu amplamente utilizada em sistemas de automação predial para edifícios inteligentes.',
            bluetooth: 'O Bluetooth é uma tecnologia sem fio para comunicação entre dispositivos, amplamente utilizada em hotéis inteligentes, casas inteligentes e outras áreas.'
        }
    },
    services: {
        title: 'Cenários de Aplicação',
        features: {
            smartHome: {
                title: 'Casa Inteligente',
                desc: 'Rompa as limitações das casas tradicionais para criar um espaço de convivência inteligente em todos os cenários. Com suporte a vários protocolos, como Zigbee e Wi-Fi, permite a interconexão de dispositivos e a troca de cenas de forma contínua. Desbloqueie um estilo de vida altamente eficiente e conveniente com operações minimalistas, trazendo o calor da tecnologia para sua experiência de moradia.'
            },
            security: {
                title: 'Segurança Inteligente',
                desc: 'Uma central de alarme de segurança emparelhada com uma plataforma de monitoramento profissional para construir um sistema de segurança integrado. Como núcleo do sistema, a central se conecta a vários detectores (infravermelho, fumaça, botões de emergência) por meio do protocolo de 433MHz, permitindo alertas em tempo real para invasões, incêndios e emergências.'
            },
            hotel: {
                title: 'Hotel Inteligente',
                desc: 'Focada em IoT e combinada com uma plataforma de gestão de equipamentos hoteleiros, esta solução conecta quartos inteligentes, operações de recepção e serviços de quarto, oferecendo valor duplo tanto para os hóspedes quanto para a administração do hotel.'
            },
            building: {
                title: 'Automação Predial',
                desc: 'Baseada em RTU e configurada por meio de um painel de gestão, suporta a integração de dispositivos Modbus para obter facilmente monitoramento centralizado, controle inteligente e gestão de energia dos equipamentos do edifício, transformando edifícios tradicionais em inteligentes.'
            }
        }
    },
    software: {
        title: 'Software e Plataformas',
        steps: {
            cms: { title: 'Centro de Recebimento de Alarmes', desc: 'Clique para visitar' },
            kooyii: { title: 'Kooyii', desc: 'Passe o mouse para escanear e baixar' },
            elderly: { title: 'Cuidado Inteligente para Idosos', desc: 'Experiência ainda não disponível. Entre em contato com vendas para mais detalhes.' },
            hotel: { title: 'Hotel Inteligente', desc: 'Experiência ainda não disponível. Entre em contato com vendas para mais detalhes.' },
            building: { title: 'Automação Predial', desc: 'Experiência ainda não disponível. Entre em contato com vendas para mais detalhes.' },
            more: { title: 'Mais Cenários', desc: 'Entre em contato com nossa equipe de vendas para aconselhamento profissional.' }
        }
    },
    solutions: {
        services: {
            title: 'Nossos Serviços',
            features: {
                hardware: {
                    title: 'Personalização de Hardware',
                    desc: 'Serviços exclusivos de design e fabricação de ponta a ponta, desde as placas PCBA principais até a estética completa do dispositivo. Cobre o design de circuitos, seleção de componentes, layout de PCB, depuração funcional, moldes de invólucro, materiais e proteção estrutural.'
                },
                software: {
                    title: 'Personalização de Software',
                    desc: 'Desenvolvimento de aplicativos e sistemas web sob medida com base em suas necessidades de negócios reais, incluindo aplicativos móveis (iOS/Android), páginas web para PC e gerenciamento de back-end. Fornecendo uma solução digital altamente eficiente adaptada ao seu modelo operacional.'
                },
                server: {
                    title: 'Implantação Privada',
                    desc: 'Implante sistemas, plataformas ou aplicativos inteiramente em seus próprios servidores ou ambientes de intranet designados. Os dados e serviços funcionam de forma completamente independente, alcançando controle autônomo total.'
                }
            }
        },
        whyUs: {
            title: 'Por Que Nos Escolher?',
            benefits: {
                oneStop: {
                    title: 'Serviço Completo (One-Stop)',
                    desc: 'Nossas soluções cobrem software e hardware com um alinhamento unificado de ponta a ponta, eliminando a coordenação entre várias partes, encurtando os ciclos de desenvolvimento e reduzindo os custos de comunicação.'
                },
                custom: {
                    title: 'Personalização Profunda',
                    desc: 'Os recursos do software são combinados com precisão ao desempenho do hardware, evitando problemas de compatibilidade e garantindo uma operação geral mais suave com taxas de falha mais baixas.'
                },
                expandable: {
                    title: 'Alta Escalabilidade',
                    desc: 'Nossos serviços reservam interfaces de expansão, tornando mais fácil para os clientes atualizar e expandir funcionalidades com base em necessidades futuras.'
                },
                deployment: {
                    title: 'Implantação Flexível',
                    desc: 'Seja uma implantação privada localizada ou implantação em nuvem pública, fornecemos soluções flexíveis para atender às suas necessidades.'
                }
            }
        },
        cta: {
            title: 'Pronto para atualizar seu estilo de vida?',
            desc: 'Fale com nossos especialistas em casas inteligentes hoje e deixe-nos projetar o ecossistema perfeito para você.',
            button: 'Falar com Vendas'
        }
    },
    product: {
        nav: {
            panel: 'Painéis de Controle',
            hub: 'Hubs Inteligentes',
            switch: 'Interruptores Inteligentes',
            curtain: 'Cortinas Inteligentes',
            sensor: 'Sensores',
            lighting: 'Iluminação Inteligente',
            security: 'Segurança Inteligente',
            doorlock: 'Fechaduras Inteligentes'
        },
        sub: {
            '4inch': '4 Polegadas',
            '5inch': '5 Polegadas',
            '6inch': '6 Polegadas',
            '7inch': '7 Polegadas',
            '8inch': '8 Polegadas',
            '10inch': '10 Polegadas',
            '1gang': '1 Tecla',
            '2gang': '2 Teclas',
            '3gang': '3 Teclas',
            '4gang': '4 Teclas',
            wireless: 'Sem fio',
            wired: 'Com fio',
            'openclose': 'Motor de Cortina',
            'roller': 'Persiana Rolo',
            'downlight': 'Spots e Downlights',
            'magnetic': 'Trilho Magnético',
            'strip': 'Fita LED',
            'alarm': 'Central de Alarme',
            'door': 'Sensor de Porta/Janela',
            'smoke': 'Detector de Fumaça',
            'infrared': 'Detector Infravermelho',
            'radar': 'Radar de Presença Humana',
            'water': 'Sensor de Vazamento de Água',
            'temp': 'Sensor de Temp. e Umidade',
            'indoorCam': 'Câmera Interna',
            'outdoorCam': 'Câmera Externa',
            'password': 'Fechadura com Senha',
            'fingerprint': 'Fechadura Biométrica',
            'face': 'Fechadura com Rec. Facial'
        },
        common: {
            learnMore: 'Saiba mais',
            addToCart: 'Adicionar ao carrinho',
            buyNow: 'Comprar agora',
            emptyProduct: 'Nenhum produto relacionado no momento. Fique atento...'
        },
        cart: {
            titleList: 'Lista de Solicitações',
            titleForm: 'Informações de Contato',
            empty: 'Sua lista está vazia, vá adicionar alguns produtos!',
            delete: 'Excluir',
            totalItems: 'Total de {count} produtos selecionados',
            nextStep: 'Próximo Passo: Preencher Informações',
            submit: 'Enviar Solicitação'
        },
        form: {
            name: 'Como devemos chamá-lo?',
            namePlaceholder: 'Por favor, insira seu nome',
            address: 'Endereço da Empresa',
            addressPlaceholder: 'Insira o endereço detalhado da sua empresa',
            location: 'Cidade / País',
            locationPlaceholder: 'Ex: São Paulo, Brasil',
            whatsapp: 'WhatsApp',
            whatsappPlaceholder: 'Insira seu WhatsApp para que possamos contatá-lo',
            email: 'E-mail',
            emailPlaceholder: 'Insira seu e-mail para que possamos contatá-lo',
            remark: 'Observações',
            remarkPlaceholder: 'Insira quaisquer observações para entendermos melhor suas necessidades',
            zipCode: 'CEP',
            zipCodePlaceholder: 'Insira o seu CEP'
        },
        alert: {
            fillRequired: 'Por favor, preencha todos os campos obrigatórios (marcados com *)',
            submitSuccess: 'Solicitação enviada com sucesso! Nossa equipe de vendas entrará em contato em breve.',
            confirm: 'Confirmar',
            notice: 'Aviso',
            success: 'Sucesso!'
        }
    },
    contact: {
        hero: {
            title: 'Fale Conosco',
            desc: 'Obtenha aconselhamento profissional e as soluções mais adequadas para você'
        },
        form: {
            title: 'Envie-nos uma mensagem',
            subtitle: 'Preencha o formulário abaixo e retornaremos em até 24 horas.',
            firstName: 'Nome',
            firstNamePlaceholder: 'Ex: João',
            lastName: 'Sobrenome',
            lastNamePlaceholder: 'Ex: Silva',
            email: 'E-mail corporativo',
            emailPlaceholder: "joao{'@'}empresa.com.br",
            inquiryType: 'Tipo de consulta',
            selectTopic: 'Selecione um tópico...',
            message: 'Mensagem',
            messagePlaceholder: 'Como podemos ajudá-lo?',
            submitBtn: 'Enviar Mensagem',
            sending: 'Enviando...',
            successMsg: 'Obrigado! Sua mensagem foi enviada com sucesso.'
        },
        inquiry: {
            general: 'Pergunta Geral',
            sales: 'Vendas e Distribuição',
            support: 'Suporte Técnico',
            hardware: 'OEM/ODM',
        },
        location: {
            title: 'Onde Estamos',
            officeName: 'Sede em Shenzhen',
            address: 'Sala 603, Unidade 1, Edifício 1, Praça Kailifang, Rua Lianrun, Comunidade Taoyuan, Rua Dalang, Distrito de Longhua, Shenzhen, Guangdong, China',
            phone: '+86 18926403313 Sra. Yuan'
        }
    },
    footer: {
        companyName: 'Shenzhen Golden Security Technology Co., Ltd.'
    }
}